import {
  ACCOUNT_GET,
  ACCOUNT_GET_LIST,
  ACCOUNT_EXPORT_CSV,
  ACCOUNT_VERIFY_BANK_ACCOUNT,
  ACCOUNT_REQUEST,
  ACCOUNT_SUCCESS,
  ACCOUNT_ERROR
} from "@/store/types"

import axios from "@/store/axios"

const state = {
  me: null,
  accounts: null,
  isLoading: false,
  error: null,
  totalCount: 0,
  page: 1
}

const getters = {
  getCurrentAccount: (state) => state.me,
  isAccountLoading: (state) => state.isLoading,
  getAccounts: (state) => state.accounts,
  getAccountError: (state) => state.error,
  getAccountCurrentPage: (state) => state.page,
  getAccountTotalCount: (state) => state.totalCount
}

const actions = {
  [ACCOUNT_GET]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(ACCOUNT_REQUEST)

      axios
        .get("/api/v3/accounts/me/")
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(ACCOUNT_SUCCESS, { me: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(ACCOUNT_ERROR, err)
          reject(err)
        })
    })
  },
  [ACCOUNT_GET_LIST]: ({ commit }, { page = 1 }) => {
    return new Promise((resolve, reject) => {
      commit(ACCOUNT_REQUEST)

      axios
        .get(`/api/v3/accounts/?page=${page}`)
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          resp.data.page = page
          commit(ACCOUNT_SUCCESS, { accounts: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(ACCOUNT_ERROR, err)
          reject(err)
        })
    })
  },
  [ACCOUNT_EXPORT_CSV]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit(ACCOUNT_REQUEST)

      axios
        .post("/api/v3/accounts/csv/")
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(ACCOUNT_SUCCESS)
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(ACCOUNT_ERROR, err)
          reject(err)
        })
    })
  },
  [ACCOUNT_VERIFY_BANK_ACCOUNT]: ({ commit }, { amount1, amount2 }) => {
    return new Promise((resolve, reject) => {
      commit(ACCOUNT_REQUEST)

      axios
        .post("/api/v3/accounts/verify_bank_account/", {
          amount1,
          amount2
        })
        .then((resp) => {
          if (process.env.NODE_ENV === "development") {
            console.log(resp)
          }
          commit(ACCOUNT_SUCCESS, { me: resp.data })
          resolve(resp)
        })
        .catch((err) => {
          if (process.env.NODE_ENV === "development") {
            console.log(err)
          }
          commit(ACCOUNT_ERROR, err)
          reject(err)
        })
    })
  }
}

const mutations = {
  [ACCOUNT_REQUEST]: (state) => {
    state.isLoading = true
  },
  [ACCOUNT_SUCCESS]: (state, { me, accounts } = {}) => {
    state.isLoading = false

    if (me) {
      state.me = me
    }
    if (accounts) {
      state.accounts = accounts.results
      state.page = accounts.page
      state.totalCount = accounts.count
    }
  },
  [ACCOUNT_ERROR]: (state, err) => {
    state.isLoading = false
    state.error = err
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
